<template>
  <img src="~BRAND/assets/logo-dwall.svg"/>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/logos/Dwall.vue